import * as AT from '../constants/actionTypes'

/**
 * Panel reducer
 * @param {*} state 
 * @param {*} action 
 */
function panel(state = {
	actualPanel: [],
	allActualPanel: []
}, action) {
	switch (action.type) {
		case AT.PROFILE_LOGOUT:
		case AT.RESET_ALL:
			return Object.assign({}, state, {
				actualPanel: [],
				allActualPanel: []
			})
		case AT.PANEL_LOADING_STARTED:
			return Object.assign({}, state, {
				isLoading: true,
				actualPanel: [],
				allActualPanel: [],
				error: undefined
			})
		case AT.PANEL_LOADING_FAILED:
			return Object.assign({}, state, {
				isLoading: false,
				error: action.payload.error
			})
		case AT.PANEL_LOADING_FINISHED:
			return Object.assign({}, state, {
				isLoading: false,
				actualPanel: action.payload.actualPanel,
				error: undefined
			})
		case AT.PANEL_ALL_LOADING_STARTED:
			return Object.assign({}, state, {
				isLoading: true,
				actualPanel: [],
				error: undefined
			})
		case AT.PANEL_ALL_LOADING_FAILED:
			return Object.assign({}, state, {
				isLoading: false,
				error: action.payload.error
			})
		case AT.PANEL_ALL_LOADING_FINISHED:
			return Object.assign({}, state, {
				isLoading: false,
				allActualPanel: action.payload.allActualPanel,
				error: undefined
			})
		case AT.REQUEST_ADD_EXISTING_ADDRESS_FINISHED:
		case AT.REQUEST_ADD_NEW_ADDRESS_FINISHED:
			return Object.assign({}, state, {
				isLoading: false,
				actualPanel: state.actualPanel.filter(x => x.license === action.payload.newRequest.license).length > 0 ? [...state.actualPanel.filter(x => x.license !== action.payload.newRequest.license), {
					...state.actualPanel.filter(x => x.license === action.payload.newRequest.license)[0],
					intact: false
				}].sort((a, b) => a.name.localeCompare(b.name)) : state.actualPanel,
				error: undefined
			})
		case AT.PANELCHANGE_REMOVE_TARGET_FINISHED:
		case AT.PANELCHANGE_MODIFY_TARGET_FINISHED:
			return Object.assign({}, state, {
				isLoading: false,
				actualPanel: [...state.actualPanel.filter(x => x.license !== action.payload.newPanelChange.license), {
					...state.actualPanel.filter(x => x.license === action.payload.newPanelChange.license)[0],
					intact: false
				}].sort((a, b) => a.name.localeCompare(b.name)),
				error: undefined
			})
		case AT.PANELCHANGE_REMOVING_FINISHED:
		case AT.REQUEST_REMOVING_FINISHED:
			if ((state.actualPanel.filter(x => x.license === action.payload.licens)).length === 0) return state;
			return Object.assign({}, state, {
				isLoading: false,
				actualPanel: [...state.actualPanel.filter(x => x.license !== action.payload.license), {
					...state.actualPanel.filter(x => x.license === action.payload.license)[0],
					intact: true
				}].sort((a, b) => a.name.localeCompare(b.name)),
				error: undefined
			})
		case AT.PANEL_FOR_EXPORT_LOADING_STARTED:
			return Object.assign({}, state, {
				isLoading: true,
				panelForExport: [],
				error: undefined
			})
		case AT.PANEL_FOR_EXPORT_LOADING_FAILED:
			return Object.assign({}, state, {
				isLoading: false,
				error: action.payload.error
			})
		case AT.PANEL_FOR_EXPORT_LOADING_FINISHED:
			return Object.assign({}, state, {
				isLoading: false,
				panelForExport: action.payload.actualPanel,
				error: undefined
			})
		case AT.PANEL_UI_CLEAR:
			return Object.assign({}, state, {
				error: undefined
			})
		default:
			return state;
	}
}

export default panel;